import { defineStore } from 'pinia';

export const useUserStore = defineStore('user', {
  state: () => ({
    token: null,
    isLoggedIn: true,
}),

actions: {
    setIsLoggedIn(val = false) {
        this.isLoggedIn = val; 
    },
    setToken(token) {
        this.token = token;
    },

    logout() { 
        this.token = null;
    },
},
persist: true,
});
